/**
 * Serializes a filter object into a querystring, dropping only empty values.
 *
 * Used by every lead read (table, board, facet counts) so one filter bar
 * produces the same query in both views. It deliberately does NOT drop `0`:
 * `scoreMin=0` is a legitimate filter that the previous version swallowed.
 */
export function buildQueryString(
  params: Record<string, string | number>,
): string {
  const entries = Object.entries(params).filter(([, v]) => v !== "");
  return new URLSearchParams(
    entries.map(([k, v]) => [k, String(v)]),
  ).toString();
}
